
import moment from 'moment';
import order from './order';

const times = [];
for (let i = 0; i <= 23; i++) {
    let num = i;
    if (i < 10) num = '0' + i;
    i = i.toString()
    times.push({value: i, minutes: '0', label: num + ':00'});
    times.push({value: i, minutes: '15', label: num + ':15'});
    times.push({value: i, minutes: '30', label: num + ':30'});
    times.push({value: i, minutes: '45', label: num + ':45'});
};

const time_options = [];
for (let i = 0; i <= 23; i++) {
    let num = i;
    if (i < 10) num = '0' + i;
    i = i.toString();
    time_options.push({value: i, label: num});
}

export default {
    debug: true,
    state: {
        queryString: window.location.search.substring(1),
        currentUrl: window.location.pathname,
        products: null,
        category: null,
        ancestors: null,
        miniCartQuantity: 0,
        miniCartSum: 0,
        // dates: {
        //     start: new Date().setHours(0, 0, 0, 0),
        //     end: new Date().setHours(0, 0, 0, 0)
        // },
        dates: {
            start: null,
            end: null
        },
        // timeStart: {value: 9, label: '09:00'},
        // timeEnd: {value: 12, label: '12:00'},

        // timeStart: {value: null, label: null},
        // timeEnd: {value: null, label: null},

        timeStart: {HH: null, mm: null},
        timeEnd:  {HH: null, mm: null},

        minStart: {value: null, label: null},
        minEnd: {value: null, label: null},

        time_options: time_options,
        min_options: [
            {value: 0, label: '00'},
            {value: 30, label: '30'},
        ],

        times: times,

        basket_count: null,
        basket_accessories: null,
        basket_name: null,
        basket_items: null,
        loading: false,
    },

    rate: {
        value: 1,
        count: 0
    },

    common_price: {
        price: 0,
        discount_price: 0,
        discount: 0,
        additional_cost: 0
    },

    getItemlocalStorage(key) {
        return localStorage.getItem(key);
    },

    setValuelocalStorage() {
        const dates = {
            from: moment(new Date()).set({hour: 9, minute: 0, second: 0, millisecond: 0}).format(),
            to: moment(new Date()).set({hour: 12, minute: 0, second: 0, millisecond: 0}).format()
        };
        const time = {
            timeStart: this.state.timeStart,
            timeEnd: this.state.timeEnd
        };
        this.setItemlocalStorage('chosen-dates', dates);
        this.setItemlocalStorage('chosen-time', time);
    },

    setItemlocalStorage(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    },

    removeItemLocaleStorage(key) {
        localStorage.removeItem(key);
    },

    setDatesDatepicker(datesStart, datesEnd) {
        this.state.dates.start = datesStart;
        this.state.dates.end = datesEnd;
    },

    setTimeDatepicker(timeStart, timeEnd) {
        this.state.timeStart = timeStart;
        this.state.timeEnd = timeEnd;
    },

    getItemBasketData() {
        const time = {hour: 0, minute: 0, second: 0, millisecond: 0};
        this.rate.count = 0;
        this.rate.value = 1;

        let date_end = moment(this.state.dates.end).set(time).format();
        let date_start = moment(this.state.dates.start).set(time).format();

        let dateEnd = moment(date_end);
        let dateStart = moment(date_start);

        let timeEnd = this.state.timeEnd.HH;
        let timeStart = this.state.timeStart.HH;
        let minEnd = this.state.timeEnd.mm;
        let minStart = this.state.timeStart.mm;

        if(dateEnd && dateStart && timeStart && timeEnd && minStart && minEnd) {
            let timer = dateEnd.valueOf() - dateStart.valueOf();
            let days;
            let hours;
            let mins;

            if(timeEnd && timeStart && dateEnd && dateStart && minEnd && minStart) {
                if (timer > 0) {
                    days = Math.ceil(timer / (1000 * 60 * 60 * 24));
                    hours = timeEnd - timeStart;
                    mins = minEnd - minStart;
                }
                if(timer == 0) {
                    days = 0;
                    hours = timeEnd - timeStart;
                    mins = minEnd - minStart;
                }
            }

            /* тариф за 1 неполный день */
            if ((days == 0 && hours > 3 && mins < 1) || (days == 0 && hours > 2 && mins > 0)) {
                this.rate.value = 2;
                this.rate.count = days + 1;
                this.setDiscountPeriod(0);
                return;
            }
            /* тариф посуточный */
            if (days > 0 && hours <= 0) {
                this.rate.value = 2;
                if(mins < 1 || hours < 0) {
                    this.rate.count = days;
                    this.setDiscountPeriod(days);
                }
                if (mins > 0 && hours == 0) {
                    this.rate.count = days + 1;
                    this.setDiscountPeriod(days + 1);
                }
                return;
            }
            /* тариф посуточный */
            if (days > 0 && hours > 0) {
                this.rate.value = 2;
                this.rate.count = days + 1;
                this.setDiscountPeriod(days + 1);
            }
            /* ошибка - в одном дне неверная дата */
            if (days == 0 && hours < 0) {
                this.rate.value = 1;
                this.rate.count = 0;
                this.setDiscountPeriod(0);
            }
        }
    },

    getFinalPrice(threeHoure_price, day_price, count, not_apply_number_days, discount_flag = false, discount_new_price = 0) {
        let price;
        if (discount_flag) {
            if (this.rate.value == 1){
                return discount_new_price * count
            } else {
                return discount_new_price * count * this.rate.count
            }
        }
        else if (this.rate.value == 1) {
            price = threeHoure_price;
            return price * count
        } else {
            price = day_price;
            if(not_apply_number_days == "1" || not_apply_number_days == 1) return price * count
            else return price * count * this.rate.count
        }
    },

    setDiscountPeriod(days) {
        if (days < 2) {
            order.state.discount_period = null;
            this.setFinalDiscount(0, order.state.discount_personal);
            return;
        }
        if (days == 2) {
            order.state.discount_period = 10;
            this.setFinalDiscount(10, order.state.discount_personal);
            return;
        }
        if (days == 3) {
            order.state.discount_period = 20;
            this.setFinalDiscount(20, order.state.discount_personal);
            return;
        }
        if (days == 4) {
            order.state.discount_period = 30;
            this.setFinalDiscount(30, order.state.discount_personal);
            return;
        }
        if (days == 5 || days == 6) {
            order.state.discount_period = 40;
            this.setFinalDiscount(40, order.state.discount_personal);
            return;
        }
        if (days > 6 && days < 14) {
            order.state.discount_period = 50;
            this.setFinalDiscount(50, order.state.discount_personal);
            return;
        }
        if(days > 13) {
            order.state.discount_period = 60;
            this.setFinalDiscount(60, order.state.discount_personal);
        }
    },

    setFinalDiscount(discount_period, discount_personal) {
        let period = parseInt(discount_period);
        let personal = parseInt(discount_personal);

        if(period > personal) {
            this.common_price.discount = period;
        }
        if(personal > period) {
            this.common_price.discount = personal;
        }
        if(personal == period) {
            this.common_price.discount = personal;
        }
        if(this.rate.value == 1) {
            this.common_price.discount = 0;
        }
    },

    addToBasket(data) {
        let item;
        let storage_item = JSON.parse(this.getItemlocalStorage('chosen-products'));
        if (!storage_item) item = [];
        else item = storage_item;

        item.push(data);
        this.setItemlocalStorage('chosen-products', item);

        this.checkItemBasket(data.code);
        this.getBasketCount();
    },

    checkItemBasket(code) {
        let storage_item = JSON.parse(this.getItemlocalStorage('chosen-products'));
        if (!storage_item) return false;
        else {
            let result = false;
            storage_item.forEach(item => {
                if (item.code == code) result = true;
            });
            return result;
        }
    },

    getItemBasket(code) {
        let storage_item = JSON.parse(this.getItemlocalStorage('chosen-products'));
        if (!storage_item) return null;
        else {
            let result = null;
            storage_item.forEach(item => {
                if (item.code == code) result = item;
            });
            return result;
        }
        return null;
    },

    getBasketCount() {
        let items = JSON.parse(this.getItemlocalStorage('chosen-products'));

        if (!items) this.state.basket_count = null;
        else this.state.basket_count = items.length;
    },

    getBasketItems() {
        this.state.loading = true;
        let items = JSON.parse(this.getItemlocalStorage('chosen-products'));
        // if (items) return items;
        if (items && items.length) {
            let codes = [];
            let products;
            items.forEach(i => {
                codes.push(i.code)
            });
            let url = '/api/get-cart-items';
            return axios.post(url, {codes: codes})
                .then(response => {
                    if (response.status == 200) {
                        response.data.products.forEach(item => {
                            items.forEach(i => {
                                if(i.code == item.code) {
                                    item.count = i.count;
                                    item.discount = i.discount;
                                    item.promoCodeName = i.promoCodeName;
                                    item.promoCodeId = i.promoCodeId;
                                }
                            })
                        });
                        this.state.basket_items = response.data.products;
                        this.state.loading = false;
                    }
                });
        }
        else {
            this.state.loading = false;
            return [];
        }
    },

    setAdditionalCost() {
        let price = 0;
        if(order.postData.delivery_type && order.postData.delivery_type.length > 0) {
            order.postData.delivery_type.forEach(item => {
                /*if(item.f1.trim() === 'Доставка') price = price + 12;
                if(item.f1.trim() === 'Увоз') price = price + 12;*/
            })
        }

        if(order.postData.services && order.postData.services.length > 0) {
            order.postData.services.forEach(item => {
                price = price + item.f2;
            })
        }

        if(order.postData.delivery_outside_distance){
            price = price + order.postData.delivery_outside_distance * 1
        }

        if(order.postData.pick_up_outside_distance){
            price = price + order.postData.pick_up_outside_distance * 1
        }
        this.common_price.additional_cost = price;
        this.getCommonPrice();
    },

    getCommonPrice() {
        this.common_price.price = 0;
        if(this.state.basket_items && this.state.basket_items.length) {
            this.state.basket_items.forEach(item => {
                let item_final_price = this.getFinalPrice(item.threeHoure_price, item.day_price, item.count, item.not_apply_number_days, item.discount_flag != 0 ? true : false, item.discount_new_price != null ? item.discount_new_price : 0);
                this.common_price.price = this.common_price.price + item_final_price;
            });
        }
        this.common_price.price = this.common_price.price + this.common_price.additional_cost;
    },

    updateBasketWithPrice() {
        let promoCodes = JSON.parse(this.getItemlocalStorage('promoCodes'));
        let dependences = JSON.parse(this.getItemlocalStorage('dependences'));
        let promoCode = null;
        let items = this.state.basket_items;
        let flag = true;
        items.forEach(item => {
            flag = true;
            promoCode = null;
            if (item.discount_flag == 1) {
                item.promoCodeName = null;
                item.promoCodeId = null;
                item.discount = null; //Math.round((item.discount_old_price - item.discount_new_price) * 100 / item.discount_old_price);
                item.common_price = this.getFinalPrice(item.threeHoure_price, item.day_price, item.count, item.not_apply_number_days, true, item.discount_new_price);
                item.common_discount = 0; //Math.round(item.common_price * item.discount / 100);
                item.finally_price = item.common_price; //this.getFinalPrice(item.threeHoure_price, item.day_price, item.count, item.not_apply_number_days, true, item.discount_new_price);
            } else {
                if (promoCodes != undefined && promoCodes != null && promoCodes.length > 0) {
                    if (dependences[item.code]) {
                        if (dependences[item.code].length > 0) {
                            dependences[item.code].forEach(dependencesItem => {
                                promoCode = promoCodes.find(promoCodesItem => {
                                    return dependencesItem.id == promoCodesItem.id;
                                });
                                if (promoCode != null && promoCode.discount > this.common_price.discount) {
                                    item.discount = promoCode.discount;
                                    item.promoCodeName = promoCode.name;
                                    item.promoCodeId = promoCode.id;
                                    flag = false;
                                }
                            });
                        }
                    }
                }
                if (flag) {
                    item.promoCodeName = null;
                    item.promoCodeId = null;
                    item.discount = null;
                }
                item.common_price = this.getFinalPrice(item.threeHoure_price, item.day_price, item.count, item.not_apply_number_days, false, 0);
                if (item.promoCodeName != null) {
                    item.common_discount = item.common_price * item.discount / 100;
                    item.finally_price = item.common_price - item.common_discount;
                } else if (item.not_apply_discount == 0) {
                    item.common_discount = item.common_price * this.common_price.discount / 100;
                    item.finally_price = item.common_price - item.common_discount;
                } else {
                    item.common_discount = 0;
                    item.finally_price = item.common_price;
                }
            }
        });
        this.setItemlocalStorage('chosen-products', items);
    }
}
